// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M5.58594 16.5L10.0859 12L5.58594 7.50003L7.00015 6.08582L12.9144 12L7.00015 17.9142L5.58594 16.5ZM12.0859 16.5L16.5859 12L12.0859 7.50003L13.5002 6.08582L19.4144 12L13.5001 17.9142L12.0859 16.5Z"}}]};

const ChevronRightDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-right-double',
    ref,
    icon: element,
  },
));

ChevronRightDoubleIcon.displayName = 'ChevronRightDoubleIcon';

export default ChevronRightDoubleIcon;
